import { render, staticRenderFns } from "./MetaOnlyLabel.vue?vue&type=template&id=30a4c81d"
import script from "./MetaOnlyLabel.vue?vue&type=script&lang=js"
export * from "./MetaOnlyLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports